import React from 'react';
import { Link } from 'react-router-dom';
import { Award, Users, History, Target } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function AboutPage() {
  return <div className="bg-white" data-id="element-107">
      {/* Hero */}
      <div className="bg-gray-50 py-16 border-b border-gray-100" data-id="element-108">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-109">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-110">Über uns</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-111">
            Tradition trifft Innovation: Seit über 50 Jahren Ihr Partner für
            Sauberkeit in Aachen.
          </p>
        </div>
      </div>

      {/* History & Story */}
      <section className="py-20" data-id="element-112">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-113">
          <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-114">
            <div className="lg:w-1/2" data-id="element-115">
              <img src="https://cdn.magicpatterns.com/uploads/bsKZLkM719s4cAouArzig3/cleaningTeam.png" alt="Unser Team bei der Arbeit" className="rounded-2xl shadow-xl w-full" data-id="element-116" />
            </div>
            <div className="lg:w-1/2" data-id="element-117">
              <div className="flex items-center space-x-2 text-blue-700 font-bold mb-4" data-id="element-118">
                <History className="w-5 h-5" data-id="element-119" />
                <span data-id="element-120">Unsere Geschichte</span>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-121">
                Ein Familienbetrieb mit Werten
              </h2>
              <div className="space-y-4 text-gray-600 leading-relaxed" data-id="element-122">
                <p data-id="element-123">
                  Seit mehr als 50 Jahren ist die Firma Lissowski Glas- und
                  Gebäudereinigung in Aachen und Umgebung erfolgreich tätig. Was
                  als kleiner Betrieb begann, hat sich zu einem etablierten
                  mittelständischen Unternehmen entwickelt, das Tradition mit
                  modernster Technik verbindet.
                </p>
                <p data-id="element-124">
                  Als Innungsfachbetrieb der Handwerkskammer Aachen stehen wir
                  für geprüfte Qualität und Zuverlässigkeit. Wir sind stolz
                  darauf, nicht nur Dienstleister, sondern auch
                  Ausbildungsbetrieb zu sein und unser Wissen an die nächste
                  Generation weiterzugeben.
                </p>
                <p data-id="element-125">
                  Unsere besondere Stärke liegt in der Verbindung von
                  jahrzehntelanger Erfahrung mit dem Mut zu Innovationen – wie
                  unserer patentierten CleanCopter-Technologie.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy */}
      <section className="py-20 bg-blue-900 text-white" data-id="element-126">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
          <div className="text-center mb-16" data-id="element-128">
            <h2 className="text-3xl font-bold mb-4" data-id="element-129">Unsere Philosophie</h2>
            <p className="text-blue-200 max-w-2xl mx-auto" data-id="element-130">
              Mehr als nur Reinigung – wir sorgen für Werterhalt und Sicherheit.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-131">
            <div className="bg-blue-800 p-8 rounded-xl border border-blue-700" data-id="element-132">
              <Target className="w-10 h-10 text-emerald-400 mb-6" data-id="element-133" />
              <h3 className="text-xl font-bold mb-4" data-id="element-134">Unser Ziel</h3>
              <p className="text-blue-100" data-id="element-135">
                Wir unterstützen unsere Kunden bei der Sicherstellung der
                technischen Funktionen von Gebäuden und beim Erhalt eines
                repräsentativen Erscheinungsbildes.
              </p>
            </div>
            <div className="bg-blue-800 p-8 rounded-xl border border-blue-700" data-id="element-136">
              <Award className="w-10 h-10 text-amber-400 mb-6" data-id="element-137" />
              <h3 className="text-xl font-bold mb-4" data-id="element-138">Qualität</h3>
              <p className="text-blue-100" data-id="element-139">
                Durch kontinuierliche Weiterbildung und modernste Technik
                garantieren wir höchste Standards. Unser Team umfasst Meister
                und staatlich geprüfte Desinfektoren.
              </p>
            </div>
            <div className="bg-blue-800 p-8 rounded-xl border border-blue-700" data-id="element-140">
              <Users className="w-10 h-10 text-blue-400 mb-6" data-id="element-141" />
              <h3 className="text-xl font-bold mb-4" data-id="element-142">Mitarbeiter</h3>
              <p className="text-blue-100" data-id="element-143">
                Mitarbeiterzufriedenheit steht bei uns ganz oben. Ein angenehmes
                Betriebsklima, Aufstiegschancen und Weiterbildung sind für uns
                selbstverständlich.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gray-50" data-id="element-144">
        <div className="max-w-3xl mx-auto text-center px-4" data-id="element-145">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-146">
            Werden Sie Teil unserer Geschichte
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-147">
            Ob als Kunde oder Mitarbeiter – wir freuen uns darauf, Sie
            kennenzulernen.
          </p>
          <div className="flex justify-center gap-4" data-id="element-148">
            <Link to="/kontakt" data-id="element-149">
              <Button variant="primary" data-id="element-150">Kontakt aufnehmen</Button>
            </Link>
            <Link to="/karriere" data-id="element-151">
              <Button variant="outline" data-id="element-152">Karriere bei Lissowski</Button>
            </Link>
          </div>
        </div>
      </section>
    </div>;
}